import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { CustomSnackBarComponent } from '@core/components/custom-snackbar/custom-snackbar.component';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '../../../@fuse/services/translation-loader.service';
import { sentry } from '../../../sentry';
import { getErrorCode } from '../utils/get-error-code';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { KNOW_ERRORS } from './know-errors';

@Injectable({
  providedIn: 'root'
})
export class CustomMessagesService {
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly translateService: TranslateService,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public info(key: string, params?: Record<string, any>): void {
    this.openSnackBar({ key, type: 'info', params });
  }

  public custom(key: string, icon: string, params?: Record<string, any>): void {
    this.openSnackBar({ icon, key, type: 'custom', params });
  }

  public success(key: string, params?: Record<string, any>, action?: { text: string; callback: () => void; }): void {
    this.openSnackBar({ key, type: 'success', params, action });
  }

  public error(key: string | Error, params?: Record<string, any>): void {
    if (key instanceof Error) {
      key = KNOW_ERRORS[getErrorCode(key)] || 'ERRORS.UNKNOWN';
      if (key === 'ERRORS.UNKNOWN') {
        sentry.captureException(key);
      }
    }

    this.openSnackBar({ key, type: 'error', params });
  }

  public copied(key: string, params?: Record<string, any>): void {
    this.openSnackBar({ key, type: 'copied', params });
  }

  private openSnackBar({ icon, key, params, type, action }: Record<string, any>): void {
    this.snackBar.openFromComponent(CustomSnackBarComponent, {
      duration: 5000,
      horizontalPosition: 'left',
      panelClass: 'custom-snackbar--white-background',
      data: {
        type: type,
        icon: icon,
        action,
        message: this.translateService.instant(key, params || {}),
      }
    });
  }
}
